// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gallery[data-v-41246a6b] .slick-slide>div{outline:0}.gallery[data-v-41246a6b] .media-wrap{outline:0;display:block!important}.gallery[data-v-41246a6b] .media-item{pointer-events:none}", ""]);
// Exports
module.exports = exports;
